export default "__VITE_ASSET__BdlLZdSB__"